(function () {
  'use strict';
  if (window.fimmCardPreviewBound) return;
  window.fimmCardPreviewBound = true;
  var touch = null;
  var suppressed = null;
  var hovered = null;

  function find(target) { return target instanceof Element ? target.closest('[data-fimm-preview]') : null; }
  function show(el) {
    var image = el.querySelector('.fimm-card-preview-image');
    if (image && image.complete && image.naturalWidth) image.dataset.ready = 'true';
    el.setAttribute('data-previewing', '');
  }
  function hide(el) { if (el) el.removeAttribute('data-previewing'); }
  function cancelTouch() {
    if (!touch) return;
    clearTimeout(touch.timer);
    if (touch.held) suppressed = { el: touch.el, until: Date.now() + 800 };
    hide(touch.el);
    touch = null;
  }
  document.addEventListener('load', function (e) {
    if (e.target instanceof HTMLImageElement && e.target.classList.contains('fimm-card-preview-image') && e.target.naturalWidth) e.target.dataset.ready = 'true';
  }, true);
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var el = find(e.target);
    if (!el || el.contains(e.relatedTarget)) return;
    hide(hovered);
    hovered = el;
    show(el);
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var el = find(e.target);
    if (el && !el.contains(e.relatedTarget)) { hide(el); hovered = null; }
  });
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse') return;
    cancelTouch();
    suppressed = null;
    var el = find(e.target);
    if (!el || !e.isPrimary) return;
    touch = { el: el, id: e.pointerId, x: e.clientX, y: e.clientY, held: false };
    touch.timer = setTimeout(function () {
      if (!touch) return;
      touch.held = true;
      show(touch.el);
    }, 280);
  }, { passive: true });
  document.addEventListener('pointermove', function (e) {
    if (touch && e.pointerId === touch.id && Math.hypot(e.clientX - touch.x, e.clientY - touch.y) > 10) cancelTouch();
  }, { passive: true });
  document.addEventListener('pointerup', function (e) {
    if (!touch || e.pointerId !== touch.id) return;
    // Only a completed hold consumes the following click; ordinary taps navigate.
    cancelTouch();
  }, { passive: true });
  document.addEventListener('pointercancel', cancelTouch, { passive: true });
  document.addEventListener('scroll', cancelTouch, { passive: true, capture: true });
  window.addEventListener('blur', function () { cancelTouch(); hide(hovered); hovered = null; });
  document.addEventListener('contextmenu', function (e) {
    if (touch && find(e.target) === touch.el) e.preventDefault();
  });
  document.addEventListener('click', function (e) {
    if (!suppressed || e.detail === 0 || Date.now() > suppressed.until || find(e.target) !== suppressed.el) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    suppressed = null;
  }, true);
})();
